import createPublicI18nProvider from 'I18n/init/providers/createPublicI18nProvider';
import lang from 'i2l?query=sporks!../../lang/en.lyaml';
import registerAllData from 'I18n/init/register/sync/registerAllData';
import * as localeUtils from './locale'; // re-import utils to allow mocking in tests

const DEFAULT_LANGUAGE = 'en';
const ES_US_LOCALE = 'es-US';
const ES_MX_LOCALE = 'es-MX';
// See https://issues.hubspotcentral.com/browse/PAYSUP-814 for why we have to account for es-419
const ES_LATAM_LOCALE = 'es-419';
export const normalizeLocale = locale => {
  try {
    return Intl.getCanonicalLocales(locale)[0];
  } catch (_unused) {
    return DEFAULT_LANGUAGE;
  }
};

// Copied from https://git.hubteam.com/HubSpot/I18n/blob/4bc9ae0ed020b4a155887adc48d4a414bc097729/static/js/init/providers/createPublicI18nProvider.ts#L21
export const getBrowserLocale = () => {
  let locale = DEFAULT_LANGUAGE;
  if (navigator && navigator.languages && navigator.languages[0]) {
    locale = navigator.languages[0];
  } else if (navigator && navigator.language) {
    locale = navigator.language;
  }
  return normalizeLocale(locale);
};

// Overrides certain locale values since they're not supported by our i18n setup
// Full context here: https://hubspot.slack.com/archives/C6PL2HX0C/p1699986304019579
export const setAppLocale = I18nPublicProvider => {
  let locale = localeUtils.getBrowserLocale();
  if (locale === ES_US_LOCALE || locale === ES_LATAM_LOCALE) {
    locale = ES_MX_LOCALE;
  }
  I18nPublicProvider.setLocale({
    locale,
    langEnabled: true
  });
};
const getCountryFromLocale = locale => {
  const parts = locale.split('-');
  // Finds "GB" (skips "en", numeric subtags like "419", and script subtags like "Hant")
  const regionSubtag = parts.find(part => part.length === 2 && /^[A-Z]{2}$/.test(part));
  return regionSubtag ? regionSubtag.toLowerCase() : null;
};
export const getDefaultCountry = shippableCountries => {
  const lowerCaseShippableCountries = shippableCountries.map(c => c.toLowerCase());
  if (lowerCaseShippableCountries.length === 1) {
    return lowerCaseShippableCountries[0];
  }
  const browserCountry = getCountryFromLocale(getBrowserLocale());
  if (!browserCountry) {
    return '';
  }
  if (lowerCaseShippableCountries.length > 0) {
    return lowerCaseShippableCountries.includes(browserCountry) ? browserCountry : '';
  }
  return browserCountry;
};
export const getLangPromise = () => {
  const I18nPublicProvider = createPublicI18nProvider({
    manuallySetLocale: true
  });
  const langAvailable = Promise.all([I18nPublicProvider.register(lang), registerAllData(I18nPublicProvider)]);
  localeUtils.setAppLocale(I18nPublicProvider);
  return langAvailable;
};